import { render } from "./app-download-cta.vue?vue&type=template&id=1b0168ec"
import script from "./app-download-cta.vue?vue&type=script&lang=js"
export * from "./app-download-cta.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nathan/Dev/justcuts-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__